/*Import Estilo*/
import '../institucional.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';

/*Import SEO*/
import { SEOHelmet } from '../../../hooks/useSEO';

export default function FreteEntrega() {
    const seoData = {
        title: 'Frete e Entrega - Fracaro Store',
        description: 'Informações sobre frete, prazos de entrega e política de envio da Fracaro Store. Frete grátis em compras acima de R$ 200.',
        keywords: 'frete, entrega, envio, prazo, fracaro store, frete grátis',
        url: window.location.href,
    };

    return (
        <section className='container-principal-institucional'>
            <SEOHelmet {...seoData} />
            <Cabecalho />
            <CookieAceite />
            <main>
                <div className='hero-institucional'>
                    <div className='hero-overlay'>
                        <h1>Frete e Entrega</h1>
                        <p>Tudo sobre envio e prazos de entrega</p>
                    </div>
                </div>

                <div className='conteudo-institucional'>
                    <h2>1. Frete Grátis</h2>
                    <div className='destaque-box'>
                        <p>Compras acima de R$ 200,00 possuem frete grátis para todo o Brasil!</p>
                    </div>

                    <h2>2. Modalidades de Envio</h2>
                    <p>Oferecemos as seguintes opções de entrega:</p>
                    <ul>
                        <li>
                            <strong>PAC (Correios):</strong> Entrega econômica com prazo de 7 a 10 dias úteis. 
                            Ideal para quem não tem pressa e busca economia no frete.
                        </li>
                        <li>
                            <strong>SEDEX (Correios):</strong> Entrega expressa com prazo de 2 a 3 dias úteis. 
                            Melhor opção para quem precisa receber o produto rapidamente.
                        </li>
                        <li>
                            <strong>Retirada na Loja:</strong> Retire seu pedido gratuitamente em nosso 
                            endereço na região da Grande São Paulo.
                        </li>
                    </ul>

                    <h2>3. Prazos de Entrega</h2>
                    <p>
                        Os prazos de entrega são contados em <strong>dias úteis</strong> a partir da confirmação 
                        do pagamento. Os prazos podem variar conforme a região de destino.
                    </p>
                    <ul>
                        <li><strong>Capital de São Paulo e Guarulhos:</strong> Até 3 dias úteis (entrega própria disponível)</li>
                        <li><strong>Região Metropolitana de SP:</strong> 3 a 5 dias úteis</li>
                        <li><strong>Demais capitais:</strong> 5 a 8 dias úteis</li>
                        <li><strong>Interior e outras regiões:</strong> 7 a 12 dias úteis</li>
                    </ul>

                    <div className='destaque-box'>
                        <p>Em períodos de alta demanda (Black Friday, Natal, Dia das Mães), os prazos podem sofrer atrasos. Recomendamos antecipar suas compras.</p>
                    </div>

                    <h2>4. Cálculo do Frete</h2>
                    <p>
                        O valor do frete é calculado automaticamente no momento da compra com base em:
                    </p>
                    <ul>
                        <li>CEP de destino</li>
                        <li>Peso e dimensões dos produtos</li>
                        <li>Modalidade de envio escolhida</li>
                    </ul>

                    <h2>5. Rastreamento</h2>
                    <p>
                        Após o envio do seu pedido, você receberá o <strong>código de rastreamento</strong> por 
                        email e poderá acompanhar a entrega diretamente na área "Meus Pedidos" do site 
                        ou pelo site dos Correios.
                    </p>

                    <h2>6. Problemas na Entrega</h2>
                    <p>Em caso de problemas com a entrega, como:</p>
                    <ul>
                        <li>Produto não entregue dentro do prazo</li>
                        <li>Produto danificado durante o transporte</li>
                        <li>Endereço incorreto ou destinatário ausente</li>
                    </ul>
                    <p>
                        Entre em contato conosco imediatamente para que possamos resolver a situação 
                        da melhor forma possível.
                    </p>

                    <div className='info-contato'>
                        <h3>Problemas com entrega?</h3>
                        <p>
                            WhatsApp: <a href="https://wa.me/5511997636154" target="_blank" rel="noopener noreferrer">(11) 99763-6154</a><br />
                            Email: <a href="mailto:fracarostore@gmail.com">fracarostore@gmail.com</a>
                        </p>
                    </div>

                    <p className='ultima-atualizacao'>Última atualização: Janeiro de 2026</p>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
